import { Body, Textarea } from '@cognite/cogs.js';
import styled from 'styled-components/macro';

export const StyledTextarea = styled(Textarea)`
  min-height: 80px;
  flex-direction: column;
  display: flex;
`;

export const SelectWrapper = styled.div`
  max-width: 500px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const HintText = styled(Body)`
  font-style: italic;
  color: var(--cogs-greyscale-grey6);
`;

export const WarningPanel = styled.div`
  padding: 16px;
  background: var(--cogs-greyscale-grey4);
  border: 1px solid var(--cogs-warning);
  border-radius: 4px;
  color: var(--cogs-warning);
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InfoPanel = styled.div`
  padding: 16px;
  background: var(--cogs-greyscale-grey4);
  border: 1px solid var(--cogs-border-default);
  border-radius: 4px;
  color: var(--cogs-greyscale-grey6);
`;
